import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const startUiNodeSpec: UiNodeSpec<'start'> = {
    canCopy: false,
    canDelete: false,
    canResize: false,
    requiredSockets: 'none',
    cfg: () => ({ id: getUID(), kind: 'start', disabled: false }),
    controls: () => ({}),
    inputs: () => ({}),
    kindLabel: 'Start',
    nodeCategory: 'events',
    suppressNode: true,
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: () => true,
};
